/* ================================================== */
/* SVG4EVERYBODY
/* ================================================== */

$(document).ready(function() { svg4everybody(); });